import LangEnum from '../../../../../../../../lang/LangEnum';
import { CatalogCreationAccessFieldName } from '../../../../../../creation/catalogCreationAccess.types';

export const CATALOG_ACCESS_PREVIEW_LIMIT = 10;

export const CATALOG_ACCESS_TAB_LABEL_BY_FIELD: Record<CatalogCreationAccessFieldName, LangEnum> = {
  classificationPermissions: LangEnum.GLOBAL_CLASSIFICATIONS,
  customers: LangEnum.GLOBAL_CUSTOMERS,
  salesRepresentatives: LangEnum.GLOBAL_SALES_REPS,
};
